"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* tslint:disable */

var colors_1 = require("./colors");

exports.theme = {
  /* Get the color palette from colors.ts */
  colors: colors_1.colors,
  colorsV2: colors_1.colorsV2,
  spacing: {
    small: 8,
    standard: 24
  },

  /* General theme settings */
  backgroundColor: colors_1.colors.OffWhite,
  backgroundDarkColor: colors_1.colors.Clay100,
  borderRadius: "4",
  transition: "300ms ease-out",
  breakpoints: {
    widgetUp: "@media (min-width: 300px)",
    mobileUp: "@media (min-width: 480px)",
    smallTabletUp: "@media (min-width: 600px)",
    tabletUp: "@media (min-width: 768px)",
    tabletLandscapeUp: "@media (min-width: 880px)",
    desktopUp: "@media (min-width: 1200px)",
    desktopDown: "@media (max-width: 1200px)",
    largeDesktopUp: "@media (min-width: 1440px)",
    smallTabletDown: "@media (max-width: 600px)",
    tabletDown: "@media (max-width: 768px)",
    tabletLandscapeDown: "@media (max-width: 880px)"
  },

  /* App header bar */
  headerHeight: "56",
  headerBackgroundColor: colors_1.colors.OffWhite,

  /* Sidebar */
  sideBarWidth: "256",
  sideBarBackgroundColor: colors_1.colors.Teal100,

  /* Typography */
  primaryFont: "Apercu Pro Regular",
  baseFontSize: "18px",
  fontSizes: {
    xxsmall: "0.8em",
    xsmall: "0.9em",
    small: "1.0em",
    medium: "1.25em",
    large: "1.563em",
    xlarge: "1.953125em",
    x2large: "2.441em",
    x3large: "3.051875em",
    x4large: "3.815em",
    x5large: "4.768em"
  },

  /* Text colors */
  primaryColor: colors_1.colors.Transparent.Black80,
  primaryDarkColor: colors_1.colors.Transparent.White98,
  secondaryColor: colors_1.colors.Transparent.Black58,
  secondaryDarkColor: colors_1.colors.Transparent.White80,

  /* Links */
  lightLinkColor: colors_1.colors.Teal80,
  darkLinkColor: colors_1.colors.Red100,
  lightLinkHoverColor: colors_1.colors.Teal60,
  darkLinkHoverColor: colors_1.colors.Red80,

  /* Buttons */
  primaryButton: {
    buttonColor: colors_1.colors.Red80,
    borderColor: colors_1.colors.Red100,
    textColor: colors_1.colors.Transparent.White98,
    buttonHoverColor: colors_1.colors.Red100,
    borderHoverColor: colors_1.colors.Red100,
    textHoverColor: colors_1.colors.White,
    buttonActiveColor: colors_1.colors.Red80,
    borderActiveColor: colors_1.colors.Red100,
    textActiveColor: colors_1.colors.Transparent.White86
  },
  secondaryButton: {
    buttonColor: colors_1.colors.Teal12,
    borderColor: colors_1.colors.Teal100,
    textColor: colors_1.colors.Teal100,
    buttonHoverColor: colors_1.colors.Teal100,
    borderHoverColor: colors_1.colors.Teal100,
    textHoverColor: colors_1.colors.OffWhite,
    buttonActiveColor: colors_1.colors.Teal60,
    borderActiveColor: colors_1.colors.Teal100,
    textActiveColor: colors_1.colors.OffWhite
  },
  flatLightButton: {
    textColor: colors_1.colors.Red100,
    textHoverColor: colors_1.colors.Red80,
    textActiveColor: colors_1.colors.Red100
  },
  flatDarkButton: {
    textColor: colors_1.colors.Turquoise100,
    textHoverColor: colors_1.colors.Turquoise60,
    textActiveColor: colors_1.colors.Turquoise100
  },

  /* Horizontal rules */
  lightHRColor: colors_1.colors.Transparent.Black20,

  /* Input Labels */
  labelColor: colors_1.colors.Transparent.Black80,
  labelColorHover: colors_1.colors.Black,

  /* Inputs */
  inputBackgroundColor: colors_1.colors.Transparent.White80,
  inputBorderColor: colors_1.colors.Transparent.Black14,
  inputBorderColorHover: colors_1.colors.Transparent.Black33,
  inputBorderColorFocus: colors_1.colors.Teal80,
  inputColor: colors_1.colors.Transparent.Black80,
  inputColorFocus: colors_1.colors.Black,
  inputHelperTextColor: colors_1.colors.Transparent.Black58,
  inputErrorColor: colors_1.colors.Red100,
  inputSizes: {
    xsmall: 3,
    small: 6,
    medium: 8,
    large: 15
  },

  /* Paper */
  paperColor: colors_1.colors.White,
  paperShadowColor: colors_1.colors.Transparent.Black14
};
exports.silvur = {
  colors: colors_1.colorsV3,
  typography: {
    fontFamily: 'DM Sans',
    fontWeight: {
      regular: 400,
      medium: 500
    }
  },
  spacing: {
    base: 8
  }
};
/* tslint:enable */